import { render, staticRenderFns } from "./DrawPolygon.vue?vue&type=template&id=4275861e&scoped=true"
import script from "./DrawPolygon.vue?vue&type=script&lang=js"
export * from "./DrawPolygon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4275861e",
  null
  
)

export default component.exports